export const DIALOG = {
  NAME: 'Analytics Dialog',
  CLOSE_BUTTON_LABEL: 'Close Dialog',
  COPY_JSON_BUTTON_LABEL: 'Copy Json',
};
